import api from "src/api/axiosInstance";
import { ProductCategory } from "src/enum/ProductEnum";
import { setTrendingProducts, setTrendingProductsError, setTrendingProductsLoading } from "src/store/slices/trendingProducts-slice";
import { store } from "src/store/store";


export const fetchTrendingProducts = async () => {
  store.dispatch(setTrendingProductsLoading()); 
  try {
    const response = await api.post(
      '/products-filter?page=1&limit=10', {
        collectionType: ProductCategory.Trending
      }
    );

    const products = response.data.status === 0 ? response.data.data : [];    
    store.dispatch(setTrendingProducts(products));
    
    return products;
  } catch (error) {
    console.error("Error fetching trending products:", error);
    
    // Dispatch error action
    store.dispatch(setTrendingProductsError(error.message || "Failed to fetch trending products"));
    
    return [];
  }
};


export const fetchSimilarProducts = async (slug, page = 1, limit = 12) => {  
  try {
    const response = await api.get(
      `/productsimilar/${slug}?page=${page}&limit=${limit}`);
    
    return response.data.status === 0 ? response.data.data : [];
  } catch (error) {
    console.error("Error fetching similar products:", error);
    return [];
  }
};

/**
 * Fetches product reviews for a specific product ID
 * @param {number} productId - The ID of the product
 * @param {number} page - Page number for pagination
 * @param {number} limit - Number of reviews per page
 * @returns {Promise<Array>} - Array of product reviews
 */
export const fetchProductReviews = async (productId, page = 1, limit = 25) => {
  try {
    const response = await api.get(`/productreviews/${productId}?page=${page}&limit=${limit}`);
    return response.data?.data || []; // Access the data property from the response
  } catch (error) {
    console.error("Error fetching product reviews:", error);
    return [];
  }
};

/**
 * Fetches product rating summary and distribution
 * @param {number[]} productIds - Array of product IDs
 * @returns {Promise<Object>} - Rating summary and distribution
 */
export const fetchProductRatings = async (productId) => {
  try {
    const response = await api.get(`/ratings/product/${productId}`);
     return response.data || {
      ProductRatingSummary: [],
      RatingDistribution: []
    };
  } catch (error) {
    console.error("Error fetching product ratings:", error);
    return {
      ProductRatingSummary: [],
      RatingDistribution: []
    };
  }
};

